import { MinWidth } from "@indietabletop/appkit";
import { Link } from "wouter";
import type { NavImageSrc } from "./navLinks.ts";
import { link } from "./style.css.ts";

export function DashboardLink(props: {
  heading: string;
  description: string;
  href: string;
  imageSrc?: NavImageSrc;
  disabled?: boolean;
}) {
  const { heading, description, href, imageSrc, disabled } = props;

  return (
    <Link href={href} className={link.container}>
      {imageSrc && (
        <picture>
          <source srcSet={imageSrc.default} media={MinWidth.X_WIDE} />
          <source srcSet={imageSrc.square} media={MinWidth.MEDIUM} />

          <img src={imageSrc.default} alt="" className={link.image} />
        </picture>
      )}

      <div className={link.content}>
        <div className={link.heading}>{heading}</div>
        <p className={link.text}>{description}</p>
      </div>

      {disabled && <div className={link.disabledLabel}>Under construction</div>}
    </Link>
  );
}
